/* tslint:disable */
/* eslint-disable */
/**
 * Onibi Portal Api
 * The API for the OnibiPortal Server project
 *
 * OpenAPI spec version: v1
 * Contact: info@yumebau.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { ApplyProfileSettingsRequestDto } from '../models';
import { CreatePlayerRoleRequestDto } from '../models';
import { DeleteProfileRequestDto } from '../models';
import { NewPlayerRequestDto } from '../models';
import { NewProfileRequestDto } from '../models';
import { PlayerDto } from '../models';
import { PlayerDtoPagedResponse } from '../models';
import { UpdateProfileRequestDto } from '../models';
import { YvrRole } from '../models';
/**
 * PlayerApi - axios parameter creator
 * @export
 */
export const PlayerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApplyProfileSettingsRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayerApplyDefaultResetProfilePost: async (body?: ApplyProfileSettingsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Player/applyDefaultResetProfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApplyProfileSettingsRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayerApplyPlayerSettingsPost: async (body?: ApplyProfileSettingsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Player/applyPlayerSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NewPlayerRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayerCreatePlayerPost: async (body?: NewPlayerRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Player/createPlayer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NewProfileRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayerCreatePlayerProfilePost: async (body?: NewProfileRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Player/createPlayerProfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new player role.
         * @param {CreatePlayerRoleRequestDto} [body] The role creation request containing context name and role name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayerCreatePlayerRolePost: async (body?: CreatePlayerRoleRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Player/createPlayerRole`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteProfileRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayerDeletePlayerProfileDelete: async (body?: DeleteProfileRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Player/deletePlayerProfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of all the players in the game.
         * @param {string} [contextName] The name of the context to get the players from.
         * @param {number} [page] The page number to get.
         * @param {number} [pageSize] The number of players to get per page.
         * @param {string} [sortBy] The property to sort the players by.
         * @param {boolean} [sortDesc] Whether to sort the players in descending order.
         * @param {boolean} [includeDeleted] Whether to include deleted players.
         * @param {boolean} [playerProfile] Whether to filter the players to only player profiles.
         * @param {string} [search] The search string to filter the players by.
         * @param {boolean} [excludeServerUsers] When true, excludes users with MatchDataWriter or ServerAdmin roles (shows only players). When false, shows only users with MatchDataWriter or ServerAdmin roles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayerGetPlayersGet: async (contextName?: string, page?: number, pageSize?: number, sortBy?: string, sortDesc?: boolean, includeDeleted?: boolean, playerProfile?: boolean, search?: string, excludeServerUsers?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Player/getPlayers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (contextName !== undefined) {
                localVarQueryParameter['contextName'] = contextName;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDesc !== undefined) {
                localVarQueryParameter['sortDesc'] = sortDesc;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }

            if (playerProfile !== undefined) {
                localVarQueryParameter['playerProfile'] = playerProfile;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (excludeServerUsers !== undefined) {
                localVarQueryParameter['excludeServerUsers'] = excludeServerUsers;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [contextName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayerGetRolesGet: async (contextName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Player/getRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (contextName !== undefined) {
                localVarQueryParameter['contextName'] = contextName;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateProfileRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayerUpdateProfileFavoritePut: async (body?: UpdateProfileRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Player/updateProfileFavorite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateProfileRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlayerUpdateProfileInfoPut: async (body?: UpdateProfileRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Player/updateProfileInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlayerApi - functional programming interface
 * @export
 */
export const PlayerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApplyProfileSettingsRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerApplyDefaultResetProfilePost(body?: ApplyProfileSettingsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await PlayerApiAxiosParamCreator(configuration).apiPlayerApplyDefaultResetProfilePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {ApplyProfileSettingsRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerApplyPlayerSettingsPost(body?: ApplyProfileSettingsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await PlayerApiAxiosParamCreator(configuration).apiPlayerApplyPlayerSettingsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {NewPlayerRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerCreatePlayerPost(body?: NewPlayerRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<PlayerDto>>> {
            const localVarAxiosArgs = await PlayerApiAxiosParamCreator(configuration).apiPlayerCreatePlayerPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {NewProfileRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerCreatePlayerProfilePost(body?: NewProfileRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<PlayerDto>>> {
            const localVarAxiosArgs = await PlayerApiAxiosParamCreator(configuration).apiPlayerCreatePlayerProfilePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create a new player role.
         * @param {CreatePlayerRoleRequestDto} [body] The role creation request containing context name and role name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerCreatePlayerRolePost(body?: CreatePlayerRoleRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<YvrRole>>> {
            const localVarAxiosArgs = await PlayerApiAxiosParamCreator(configuration).apiPlayerCreatePlayerRolePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {DeleteProfileRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerDeletePlayerProfileDelete(body?: DeleteProfileRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await PlayerApiAxiosParamCreator(configuration).apiPlayerDeletePlayerProfileDelete(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get a list of all the players in the game.
         * @param {string} [contextName] The name of the context to get the players from.
         * @param {number} [page] The page number to get.
         * @param {number} [pageSize] The number of players to get per page.
         * @param {string} [sortBy] The property to sort the players by.
         * @param {boolean} [sortDesc] Whether to sort the players in descending order.
         * @param {boolean} [includeDeleted] Whether to include deleted players.
         * @param {boolean} [playerProfile] Whether to filter the players to only player profiles.
         * @param {string} [search] The search string to filter the players by.
         * @param {boolean} [excludeServerUsers] When true, excludes users with MatchDataWriter or ServerAdmin roles (shows only players). When false, shows only users with MatchDataWriter or ServerAdmin roles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerGetPlayersGet(contextName?: string, page?: number, pageSize?: number, sortBy?: string, sortDesc?: boolean, includeDeleted?: boolean, playerProfile?: boolean, search?: string, excludeServerUsers?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<PlayerDtoPagedResponse>>> {
            const localVarAxiosArgs = await PlayerApiAxiosParamCreator(configuration).apiPlayerGetPlayersGet(contextName, page, pageSize, sortBy, sortDesc, includeDeleted, playerProfile, search, excludeServerUsers, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [contextName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerGetRolesGet(contextName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<YvrRole>>>> {
            const localVarAxiosArgs = await PlayerApiAxiosParamCreator(configuration).apiPlayerGetRolesGet(contextName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {UpdateProfileRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerUpdateProfileFavoritePut(body?: UpdateProfileRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<PlayerDto>>> {
            const localVarAxiosArgs = await PlayerApiAxiosParamCreator(configuration).apiPlayerUpdateProfileFavoritePut(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {UpdateProfileRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerUpdateProfileInfoPut(body?: UpdateProfileRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<PlayerDto>>> {
            const localVarAxiosArgs = await PlayerApiAxiosParamCreator(configuration).apiPlayerUpdateProfileInfoPut(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PlayerApi - factory interface
 * @export
 */
export const PlayerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {ApplyProfileSettingsRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerApplyDefaultResetProfilePost(body?: ApplyProfileSettingsRequestDto, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return PlayerApiFp(configuration).apiPlayerApplyDefaultResetProfilePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ApplyProfileSettingsRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerApplyPlayerSettingsPost(body?: ApplyProfileSettingsRequestDto, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return PlayerApiFp(configuration).apiPlayerApplyPlayerSettingsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NewPlayerRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerCreatePlayerPost(body?: NewPlayerRequestDto, options?: AxiosRequestConfig): Promise<AxiosResponse<PlayerDto>> {
            return PlayerApiFp(configuration).apiPlayerCreatePlayerPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NewProfileRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerCreatePlayerProfilePost(body?: NewProfileRequestDto, options?: AxiosRequestConfig): Promise<AxiosResponse<PlayerDto>> {
            return PlayerApiFp(configuration).apiPlayerCreatePlayerProfilePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new player role.
         * @param {CreatePlayerRoleRequestDto} [body] The role creation request containing context name and role name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerCreatePlayerRolePost(body?: CreatePlayerRoleRequestDto, options?: AxiosRequestConfig): Promise<AxiosResponse<YvrRole>> {
            return PlayerApiFp(configuration).apiPlayerCreatePlayerRolePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteProfileRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerDeletePlayerProfileDelete(body?: DeleteProfileRequestDto, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return PlayerApiFp(configuration).apiPlayerDeletePlayerProfileDelete(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of all the players in the game.
         * @param {string} [contextName] The name of the context to get the players from.
         * @param {number} [page] The page number to get.
         * @param {number} [pageSize] The number of players to get per page.
         * @param {string} [sortBy] The property to sort the players by.
         * @param {boolean} [sortDesc] Whether to sort the players in descending order.
         * @param {boolean} [includeDeleted] Whether to include deleted players.
         * @param {boolean} [playerProfile] Whether to filter the players to only player profiles.
         * @param {string} [search] The search string to filter the players by.
         * @param {boolean} [excludeServerUsers] When true, excludes users with MatchDataWriter or ServerAdmin roles (shows only players). When false, shows only users with MatchDataWriter or ServerAdmin roles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerGetPlayersGet(contextName?: string, page?: number, pageSize?: number, sortBy?: string, sortDesc?: boolean, includeDeleted?: boolean, playerProfile?: boolean, search?: string, excludeServerUsers?: boolean, options?: AxiosRequestConfig): Promise<AxiosResponse<PlayerDtoPagedResponse>> {
            return PlayerApiFp(configuration).apiPlayerGetPlayersGet(contextName, page, pageSize, sortBy, sortDesc, includeDeleted, playerProfile, search, excludeServerUsers, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [contextName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerGetRolesGet(contextName?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<YvrRole>>> {
            return PlayerApiFp(configuration).apiPlayerGetRolesGet(contextName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateProfileRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerUpdateProfileFavoritePut(body?: UpdateProfileRequestDto, options?: AxiosRequestConfig): Promise<AxiosResponse<PlayerDto>> {
            return PlayerApiFp(configuration).apiPlayerUpdateProfileFavoritePut(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateProfileRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlayerUpdateProfileInfoPut(body?: UpdateProfileRequestDto, options?: AxiosRequestConfig): Promise<AxiosResponse<PlayerDto>> {
            return PlayerApiFp(configuration).apiPlayerUpdateProfileInfoPut(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlayerApi - object-oriented interface
 * @export
 * @class PlayerApi
 * @extends {BaseAPI}
 */
export class PlayerApi extends BaseAPI {
    /**
     * 
     * @param {ApplyProfileSettingsRequestDto} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    public async apiPlayerApplyDefaultResetProfilePost(body?: ApplyProfileSettingsRequestDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return PlayerApiFp(this.configuration).apiPlayerApplyDefaultResetProfilePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {ApplyProfileSettingsRequestDto} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    public async apiPlayerApplyPlayerSettingsPost(body?: ApplyProfileSettingsRequestDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return PlayerApiFp(this.configuration).apiPlayerApplyPlayerSettingsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {NewPlayerRequestDto} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    public async apiPlayerCreatePlayerPost(body?: NewPlayerRequestDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<PlayerDto>> {
        return PlayerApiFp(this.configuration).apiPlayerCreatePlayerPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {NewProfileRequestDto} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    public async apiPlayerCreatePlayerProfilePost(body?: NewProfileRequestDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<PlayerDto>> {
        return PlayerApiFp(this.configuration).apiPlayerCreatePlayerProfilePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Create a new player role.
     * @param {CreatePlayerRoleRequestDto} [body] The role creation request containing context name and role name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    public async apiPlayerCreatePlayerRolePost(body?: CreatePlayerRoleRequestDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<YvrRole>> {
        return PlayerApiFp(this.configuration).apiPlayerCreatePlayerRolePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {DeleteProfileRequestDto} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    public async apiPlayerDeletePlayerProfileDelete(body?: DeleteProfileRequestDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return PlayerApiFp(this.configuration).apiPlayerDeletePlayerProfileDelete(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Get a list of all the players in the game.
     * @param {string} [contextName] The name of the context to get the players from.
     * @param {number} [page] The page number to get.
     * @param {number} [pageSize] The number of players to get per page.
     * @param {string} [sortBy] The property to sort the players by.
     * @param {boolean} [sortDesc] Whether to sort the players in descending order.
     * @param {boolean} [includeDeleted] Whether to include deleted players.
     * @param {boolean} [playerProfile] Whether to filter the players to only player profiles.
     * @param {string} [search] The search string to filter the players by.
     * @param {boolean} [excludeServerUsers] When true, excludes users with MatchDataWriter or ServerAdmin roles (shows only players). When false, shows only users with MatchDataWriter or ServerAdmin roles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    public async apiPlayerGetPlayersGet(contextName?: string, page?: number, pageSize?: number, sortBy?: string, sortDesc?: boolean, includeDeleted?: boolean, playerProfile?: boolean, search?: string, excludeServerUsers?: boolean, options?: AxiosRequestConfig) : Promise<AxiosResponse<PlayerDtoPagedResponse>> {
        return PlayerApiFp(this.configuration).apiPlayerGetPlayersGet(contextName, page, pageSize, sortBy, sortDesc, includeDeleted, playerProfile, search, excludeServerUsers, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [contextName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    public async apiPlayerGetRolesGet(contextName?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<YvrRole>>> {
        return PlayerApiFp(this.configuration).apiPlayerGetRolesGet(contextName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {UpdateProfileRequestDto} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    public async apiPlayerUpdateProfileFavoritePut(body?: UpdateProfileRequestDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<PlayerDto>> {
        return PlayerApiFp(this.configuration).apiPlayerUpdateProfileFavoritePut(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {UpdateProfileRequestDto} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApi
     */
    public async apiPlayerUpdateProfileInfoPut(body?: UpdateProfileRequestDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<PlayerDto>> {
        return PlayerApiFp(this.configuration).apiPlayerUpdateProfileInfoPut(body, options).then((request) => request(this.axios, this.basePath));
    }
}
